import type { HostResponseCodeDto } from "../../types/HostResponseCodeDto";
import type { HostResponseCodeEntity } from "../../types/HostResponseCodeEntity";

export const HostResponseCodeDtoToEntity = ({ ...rest }: Readonly<HostResponseCodeDto>): HostResponseCodeEntity => {
    return { ...rest };
};
